import { MoneyProto } from "@noom/noom-contracts/noom_contracts/lib/money";
import { Money } from "gql/graphql";

// Proto JSON omits default values, so `units`/`nanos` are absent for 0.
export function convertMoneyProtoToNumber(
  money: MoneyProto | Money
): number | undefined {
  return money && +(money.units ?? 0) + (money.nanos ?? 0) / 1e9;
}

export function hasPositiveMoneyValue(money?: MoneyProto | Money): boolean {
  return convertMoneyProtoToNumber(money) > 0;
}

export function subtractMoneyProtos(
  a: MoneyProto | Money | undefined,
  b: MoneyProto | Money | undefined
): MoneyProto | undefined {
  if (!a || !b) return undefined;
  if (a.currencyCode !== b.currencyCode) {
    throw new Error("Currency codes do not match");
  }
  const diff = convertMoneyProtoToNumber(a) - convertMoneyProtoToNumber(b);
  return convertNumberToMoney(diff, a.currencyCode);
}

export function multiplyMoneyProto(
  money: MoneyProto | Money | undefined,
  multiplier: number
): MoneyProto | undefined {
  if (!money) return undefined;
  return convertNumberToMoney(
    convertMoneyProtoToNumber(money) * multiplier,
    money.currencyCode
  );
}

export function calculateDiscountPercentage(
  discount: MoneyProto | Money | undefined,
  base: MoneyProto | Money | undefined
): number {
  if (!discount || !base) return 0;
  const baseNum = convertMoneyProtoToNumber(base) ?? 0;
  if (baseNum <= 0) return 0;
  const discountNum = convertMoneyProtoToNumber(discount) ?? 0;
  return Math.round((discountNum / baseNum) * 100);
}

export function convertNumberToMoney(amount, currencyCode) {
  const units = Math.trunc(amount);
  const nanos = Math.round((amount - units) * 1e9);

  const money: MoneyProto = {
    currencyCode,
    units: units.toString(),
    nanos,
  };

  return money;
}
